import http from "../http/http-config";
import { DocumentType } from "../models/documentType";

export default new class DocumentTypeService {
    getDocumentTypeList(): Promise<DocumentType[]> {
        return http.get<DocumentType[]>("DocumentTypes", {
            params: {
                countryId: 1
            }
        }).then(response => response.data)
    }
}